export default {
    ADD_PRODUCT_EXTRA(state, productExtra) {
      state.productExtras.unshift(productExtra);
      state.totalDataRow++;
    },
    SET_PRODUCT_EXTRA(state, res) {
      state.productExtras = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_PRODUCT_EXTRA(state, productExtra) {
      const productExtraIndex = state.productExtras.findIndex((p) => p.id == productExtra.id)
      Object.assign(state.productExtras[productExtraIndex], productExtra)
    },
    REMOVE_PRODUCT_EXTRA(state, productExtraId) {
      const productExtraIndex = state.productExtras.findIndex((p) => p.id == productExtraId)
      state.productExtras.splice(productExtraIndex, 1)
    },
  }
  